import React, { useState, useEffect, useCallback } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import {
  AgeAttributeCard,
  GenderAttributeCard,
  MaskAttributeCard,
  EmotionAttributeCard,
  LivenessAttributeCard,
  DeepfakeAttributeCard,
} from '@vlabs/monokit/shared/ui/atribute-cards/index.ts';

import st from './tabs.module.sass';

export function AttributesTab({
  faceId, eventId,
}) {
  const [attributes, setAttributes] = useState();

  const getAttributes = useCallback(async () => {
    if (faceId) {
      const response = await apiContainer.lunaClient.faces.attributes(faceId).get();
      setAttributes(response?.data?.attributes?.basic_attributes);
    } else if (eventId) {
      const response = await apiContainer.lunaClient.events.get(eventId);
      setAttributes(response?.data);
    }
  }, [eventId, faceId]);

  useEffect(() => {
    getAttributes();
  }, [faceId, eventId, getAttributes]);

  const {
    gender, age, mask, emotion, liveness, deepfake,
  } = attributes || {};

  return (
    <div className={st.TabPanel}>
      {gender !== undefined && <GenderAttributeCard gender={gender} />}
      {age !== null && age !== undefined && <AgeAttributeCard age={age} />}
      {typeof mask === 'number' && <MaskAttributeCard mask={mask} />}
      {typeof emotion === 'number' && <EmotionAttributeCard emotion={emotion} />}
      {liveness !== undefined && <LivenessAttributeCard liveness={liveness} />}
      {deepfake !== undefined && <DeepfakeAttributeCard deepfake={deepfake} />}
    </div>
  );
}
